export default __webpack_public_path__ + "static/media/DEX.460c76a4.png";